import { render, staticRenderFns } from "./TerminalSetup.vue?vue&type=template&id=7691cf9c&scoped=true"
import script from "./TerminalSetup.vue?vue&type=script&lang=js"
export * from "./TerminalSetup.vue?vue&type=script&lang=js"
import style0 from "./TerminalSetup.vue?vue&type=style&index=0&id=7691cf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7691cf9c",
  null
  
)

export default component.exports